import React from 'react'
import './Availabilities.scss'
import Loading from '../loading/Loading'
import { connect } from 'react-redux'
import { toggleAvailability } from '../../store/availabilities/actions'
import { convertDateToLocalTime } from '../../utils/general'

const MeetingAvailabilities = (props) => {
  if (props.isFetching) {
    return <Loading />
  }

  const { strings } = props

  return (
    <div className="meetingavailabilities">
      <h3 className="title is-4">{strings.select_moments}</h3>
      <ul>
        {props.availabilities.map((m, index) => (
          <li
            key={ index }
            onClick={() => {
              props.toggleAvailability(m.start, m.end)
              props.onConfirm()
            }}
            role="presentation"
          >
            {convertDateToLocalTime(m.start)}
          </li>
        ))}
      </ul>
      {props.availabilities.length < 1 && (
        <div>
          <p>{strings.moments_passed} </p>
          <ul>
            {props.invitees.map((m, index) => (
              <li key={index}>
                <a href={'mailto:' + m.email}>{m.email}</a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    isFetching: state.availabilities.isFetching,
    availabilities:
      state.availabilities && state.availabilities.availabilities
        ? state.availabilities.availabilities.sort((a, b) => {
          return a.start > b.start ? 1 : -1
        })
        : [],
    timeZone: state.general.timeZone,
    strings: state.languages.strings.link.meetingavailabilities,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleAvailability: (start, end) => {
      dispatch(toggleAvailability(start, end))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MeetingAvailabilities)
